import React from "react";
import "../styles/components/notice.less"

const Notice = props => {
    const {children, type, className} = props

    return (
        <div className={className ? `notice ${className}` : 'notice'}>
            {'error' === type && (
                <svg className="notice__icon" viewBox="0 0 32 32">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <path fill="#000000" d="M16,2 C23.7319865,2 30,8.2680135 30,16 C30,23.7319865 23.7319865,30 16,30 C8.2680135,30 2,23.7319865 2,16 C2,8.2680135 8.2680135,2 16,2 Z M16,4 C9.372583,4 4,9.372583 4,16 C4,22.627417 9.372583,28 16,28 C22.627417,28 28,22.627417 28,16 C28,9.372583 22.627417,4 16,4 Z M20.2426407,10.3431458 L21.6568542,11.7573593 L17.4142136,16 L21.6568542,20.2426407 L20.2426407,21.6568542 L16,17.4142136 L11.7573593,21.6568542 L10.3431458,20.2426407 L14.5857864,16 L10.3431458,11.7573593 L11.7573593,10.3431458 L16,14.5857864 L20.2426407,10.3431458 Z"></path>
                    </g>
                </svg>
            )}
            {'error' !== type && (
                <svg className="notice__icon" viewBox="0 0 32 32">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <path fill="#000000" d="M16,2 C23.7319865,2 30,8.2680135 30,16 C30,23.7319865 23.7319865,30 16,30 C8.2680135,30 2,23.7319865 2,16 C2,8.2680135 8.2680135,2 16,2 Z M16,4 C9.372583,4 4,9.372583 4,16 C4,22.627417 9.372583,28 16,28 C22.627417,28 28,22.627417 28,16 C28,9.372583 22.627417,4 16,4 Z M22,11 L23.4142136,12.4142136 L14.7071068,21.1213203 L10,16.4142136 L11.4142136,15 L14.7071068,18.2928932 L22,11 Z"></path>
                    </g>
                </svg>
            )}
            <p className="notice__msg">{children}</p>
        </div>
    )
}

export default Notice;